import React, { createContext, useContext, useState, useCallback, type ReactNode } from 'react';

export interface Space {
  id: string;
  name: string;
  is_default?: boolean;
}

interface SpacesContextType {
  spaces: Space[];
  currentSpaceId: string | null;
  setCurrentSpaceId: (id: string | null) => void;
  loading: boolean;
  refetch: () => Promise<void>;
}

const SpacesContext = createContext<SpacesContextType | undefined>(undefined);

const DEFAULT_SPACE_ID = 'default';

export function SpacesProvider({ children }: { children: ReactNode }) {
  const [spaces] = useState<Space[]>([{ id: DEFAULT_SPACE_ID, name: 'My Space', is_default: true }]);
  const [currentSpaceId, setCurrentSpaceId] = useState<string | null>(DEFAULT_SPACE_ID);
  const [loading] = useState(false);

  const refetch = useCallback(async () => {
    // No-op for now; can load spaces from API later
  }, []);

  const value: SpacesContextType = {
    spaces,
    currentSpaceId,
    setCurrentSpaceId,
    loading,
    refetch,
  };

  return (
    <SpacesContext.Provider value={value}>
      {children}
    </SpacesContext.Provider>
  );
}

export function useSpaces() {
  const ctx = useContext(SpacesContext);
  if (ctx === undefined) {
    throw new Error('useSpaces must be used within SpacesProvider');
  }
  return ctx;
}
